module.exports = __webpack_public_path__ + "static/media/us.1d23b950.svg";